import type { Term } from '../types';

/**
 * Active terms that have not ended — used for public lesson browse (current + upcoming).
 */
export function getPublicBookableTerms(terms: Term[], now: Date): Term[] {
  return terms.filter((term) => {
    if (!term.isActive) return false;
    const end = new Date(term.endDate);
    return end >= now;
  });
}
